const VISITOR_ID_STORAGE_KEY = "mariaffi-visitor-id";

let memoryVisitorId: string | null = null;

function createVisitorId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));

  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
}

export function getVisitorId() {
  if (memoryVisitorId) return memoryVisitorId;

  try {
    const storedVisitorId = localStorage.getItem(VISITOR_ID_STORAGE_KEY);
    if (storedVisitorId) {
      memoryVisitorId = storedVisitorId;
      return storedVisitorId;
    }

    const visitorId = createVisitorId();
    localStorage.setItem(VISITOR_ID_STORAGE_KEY, visitorId);
    memoryVisitorId = visitorId;
    return visitorId;
  } catch {
    memoryVisitorId = createVisitorId();
    return memoryVisitorId;
  }
}

export function withVisitorId<T extends Record<string, unknown>>(payload: T) {
  return { ...payload, visitorId: getVisitorId() };
}

